import { useEffect } from "react";

import useIdle from "react-use/lib/useIdle";
import usePreviousDistinct from "react-use/lib/usePreviousDistinct";

const useInteraction = (
  callback: (state: "idle" | "active") => void,
  timeout = 180000,
) => {
  const idle = useIdle(timeout, false);

  const prevIdle = usePreviousDistinct(idle);

  useEffect(() => {
    if (!prevIdle && idle) {
      callback("idle");
    }

    if (prevIdle && !idle) {
      callback("active");
    }
  }, [idle, prevIdle, callback]);
};

export default useInteraction;
